export const usePlans = true;
export const useMaterialsPlan = false;
export const usePrices = true;
export const usePricingTypes = true;
export const showEntityAddressInMenus = true;
export const addingCustomerDirectly = true;
export const useFinancialTarget = true;
export const useNotifications = true;